import { useSelector } from "react-redux";
import { selectCurrentUserId } from "../../features/auth/authSlice";
import { useGetInfoByStaffIdQuery } from "../../features/user/usersApiSlice";
import { getRtkErrorMessage } from "../../utils/getRtkErrorMessage";
import { useGetProductsBaseOnCategoryQuery } from "../../features/product/productApiSlice";
import { skipToken } from "@reduxjs/toolkit/query";
import { selectCategoryTypeId, selectSelectedId } from "../../features/modal/modalSlice";
import { useGetPackageItemsQuery, useGetPackageSummaryBaseOnIdQuery } from "../../features/package/packageApiSlice";
import { selectPackagedId, selectSelectedPackageDataId } from "../../features/package/packageSlice";
import { useGetClientByIdQuery } from "../../features/client/clientApiSlice";
import { selectCurrentClientId } from "../../features/client/clientSlice";
import { useGetAllProductAvailableTimeQuery } from "../../features/guest/guestApiSlice";

export const useQueryData = () => {

    const currentLogUserId = useSelector(selectCurrentUserId)
    const categoryId = useSelector(selectCategoryTypeId)
    // const selectedPackageId = useSelector(selectSelectedPackageDataId)
    const selectedPackageId = useSelector(selectPackagedId)
    const clientId = useSelector(selectCurrentClientId);
    // const selectedPackageIdUpdate = useSelector(selectSelectedId);

    // const { data: data, isError: isErrorData, error: errorData, isLoading: isLoadingData, refetch: refetchData, isFetching: isFetchingData }
    const { data: userInfo, isError: isErrorUserInfo, error: errorUserInfo, isLoading: isLoadingUserInfo, refetch: refetchUserInfo, isFetching: isFetchingUserInfo } = useGetInfoByStaffIdQuery(currentLogUserId ?? 0, {skip: currentLogUserId === null, });
    const { data: productBaseOnCategory, isError: isErrorProductBaseOnCategory, error: errorProductBaseOnCategory, isLoading: isLoadingProductBaseOnCategory, refetch: refetchProductBaseOnCategory, isFetching: isFetchingProductBaseOnCategory } = useGetProductsBaseOnCategoryQuery(categoryId ?? skipToken)
    // const { data: packageData, isError: isErrorPackageData, error: errorPackageData, isLoading: isLoadingPackageData, refetch: refetchPackageData, isFetching: isFetchingPackageData } = useGetPackageItemsQuery(selectedPackageId, { skip: !selectedPackageId})
    // const { data: packageData, isError: isErrorPackageData, error: errorPackageData, isLoading: isLoadingPackageData, refetch: refetchPackageData, isFetching: isFetchingPackageData } = useGetPackageItemsQuery(selectedPackageId, { skip: !selectedPackageId})
    const { data: packageData, isError: isErrorPackageData, error: errorPackageData, isLoading: isLoadingPackageData, refetch: refetchPackageData, isFetching: isFetchingPackageData } = useGetPackageItemsQuery(selectedPackageId ?? undefined,  { skip: selectedPackageId === null, refetchOnMountOrArgChange: true, })
    const { data: clientInfo, isError: isErrorClientInfo, error: errorClientInfo, isLoading: isLoadingClientInfo, refetch: refetchClientInfo, isFetching: isFetchingClientInfo } = useGetClientByIdQuery(clientId ?? skipToken)
    const shouldFetchPackageSummary = !!clientId && (clientInfo?.packageSummary?.length ?? 0) > 0;
    const { data: packageSummaryBaseOnIdQuery, isError: isErrorPackageSummaryBaseOnIdQuery, error: errorPackageSummaryBaseOnIdQuery, isLoading: isLoadingPackageSummaryBaseOnIdQuery, refetch: refetchPackageSummaryBaseOnIdQuery, isFetching: isFetchingPackageSummaryBaseOnIdQuery } = useGetPackageSummaryBaseOnIdQuery(shouldFetchPackageSummary ? clientId : skipToken)
    // const { data: availableProductOfClient, isError: isErrorAvailableProductOfClient, error: errorAvailableProductOfClient, isLoading: isLoadingAvailableProductOfClient, refetch: refetchAvailableProductOfClient, isFetching: isFetchingAvailableProductOfClient } = useGetAllProductAvailableTimeQuery(clientId ?? skipToken);
    
    const errorMessageUserInfo = getRtkErrorMessage(errorUserInfo);
    const errorMessageProductBaseOnCategory = getRtkErrorMessage(errorProductBaseOnCategory);
    const errorMessagePackageData = getRtkErrorMessage(errorPackageData);
    const errorMessageClientInfo = getRtkErrorMessage(errorClientInfo);
    const errorMessagePackageSummaryBaseOnIdQuery = getRtkErrorMessage(errorPackageSummaryBaseOnIdQuery);
    // const errorMessageAvailableProductOfClient = getRtkErrorMessage(errorAvailableProductOfClient);

    return {
        userInfo,
        isErrorUserInfo,
        errorUserInfo,
        isLoadingUserInfo,
        refetchUserInfo,
        isFetchingUserInfo,
        errorMessageUserInfo,

        productBaseOnCategory,
        isErrorProductBaseOnCategory,
        errorProductBaseOnCategory,
        isLoadingProductBaseOnCategory,
        refetchProductBaseOnCategory,
        isFetchingProductBaseOnCategory,
        errorMessageProductBaseOnCategory,

        packageData,
        isErrorPackageData,
        errorPackageData,
        isLoadingPackageData,
        refetchPackageData,
        isFetchingPackageData,
        errorMessagePackageData,

        clientInfo,
        isErrorClientInfo,
        errorClientInfo,
        isLoadingClientInfo,
        refetchClientInfo,
        isFetchingClientInfo,
        errorMessageClientInfo,

        packageSummaryBaseOnIdQuery,
        isErrorPackageSummaryBaseOnIdQuery,
        errorPackageSummaryBaseOnIdQuery,
        isLoadingPackageSummaryBaseOnIdQuery,
        refetchPackageSummaryBaseOnIdQuery,
        isFetchingPackageSummaryBaseOnIdQuery,
        errorMessagePackageSummaryBaseOnIdQuery,
        shouldFetchPackageSummary,
        
        // availableProductOfClient,
        // isErrorAvailableProductOfClient,
        // errorAvailableProductOfClient,
        // isLoadingAvailableProductOfClient,
        // refetchAvailableProductOfClient,
        // isFetchingAvailableProductOfClient,
        // errorMessageAvailableProductOfClient,
    }

}